import React, { useState } from 'react';
import { supabase } from '../lib/supabase';

export default function LoginScreen({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error: err } = await supabase.auth.signInWithPassword({ email, password });
    if (err) {
      setError(err.message || 'Sign in failed. Check your credentials.');
      setLoading(false);
    } else {
      setPassword('');
      onLogin();
    }
  };

  return (
    <div style={styles.screen}>
      <div style={styles.card}>
        <div style={styles.topBar} />
        <div style={styles.brand}>
          <div style={styles.logo}>
            <svg viewBox="0 0 24 24" fill="none" width="26" height="26">
              <path d="M12 2 L19 8 V15 C19 18.5 15.866 21 12 21 C8.134 21 5 18.5 5 15 V8 Z" fill="white" opacity=".95"/>
              <path d="M12 7 V15 M9 11 H15" stroke="#0A2540" strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
          </div>
          <div>
            <div style={styles.brandName}>DialyGo · Execution OS</div>
            <div style={styles.brandSub}>INTERNAL · RESTRICTED ACCESS</div>
          </div>
        </div>

        <h1 style={styles.title}>Welcome <em style={{ fontStyle:'italic', color:'#0284C7' }}>back</em>.</h1>
        <p style={styles.sub}>Sign in with the team admin credentials to access the tracker.</p>

        {error && <div style={styles.errorBox}>{error}</div>}

        <form onSubmit={handleSubmit} autoComplete="on">
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              autoComplete="username"
              required
              placeholder="admin@dialygo.com"
              style={styles.input}
              onFocus={e => e.target.style.borderColor = '#0EA5E9'}
              onBlur={e => e.target.style.borderColor = '#E4ECF4'}
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              placeholder="••••••••"
              style={styles.input}
              onFocus={e => e.target.style.borderColor = '#0EA5E9'}
              onBlur={e => e.target.style.borderColor = '#E4ECF4'}
            />
          </div>
          <button type="submit" disabled={loading} style={{ ...styles.loginBtn, opacity: loading ? 0.6 : 1 }}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
              <polyline points="10 17 15 12 10 7"/>
              <line x1="15" y1="12" x2="3" y2="12"/>
            </svg>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <div style={styles.foot}>
          <span style={{ display:'flex', alignItems:'center', gap:5 }}>
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            Encrypted · Supabase Auth
          </span>
          <span>v0.2</span>
        </div>
      </div>
    </div>
  );
}

const styles = {
  screen: {
    position:'fixed', inset:0, display:'flex', alignItems:'center', justifyContent:'center', padding:24,
    background: 'radial-gradient(900px 500px at 80% 10%, rgba(14,165,233,.18), transparent 60%), radial-gradient(700px 400px at 10% 90%, rgba(14,165,233,.12), transparent 70%), linear-gradient(180deg, #F4F8FC 0%, #E6F0F8 100%)',
  },
  card: {
    width:'100%', maxWidth:420, background:'white', border:'1px solid #E4ECF4',
    borderRadius:22, padding:'38px 36px 30px', position:'relative', overflow:'hidden',
    boxShadow:'0 32px 64px -20px rgba(10,37,64,.22), 0 12px 24px -12px rgba(10,37,64,.1)',
    animation:'loginIn .5s cubic-bezier(.4,0,.2,1)',
  },
  topBar: {
    position:'absolute', top:0, left:0, right:0, height:3,
    background:'linear-gradient(90deg,#0A2540,#0EA5E9,#10B981)',
  },
  brand: { display:'flex', alignItems:'center', gap:14, marginBottom:30 },
  logo: {
    width:44, height:44, borderRadius:12,
    background:'linear-gradient(135deg,#0A2540 0%,#1E4060 100%)',
    display:'grid', placeItems:'center',
    boxShadow:'0 4px 12px rgba(10,37,64,.18)',
  },
  brandName: { fontWeight:600, fontSize:16, letterSpacing:'-0.01em' },
  brandSub: { fontSize:11, color:'#7A8BA3', fontFamily:"'JetBrains Mono',monospace", textTransform:'uppercase', letterSpacing:'0.1em', marginTop:3 },
  title: { fontFamily:"'Fraunces',serif", fontWeight:500, fontSize:30, letterSpacing:'-0.025em', lineHeight:1.1, margin:'0 0 6px' },
  sub: { fontSize:13.5, color:'#3D5878', marginBottom:24 },
  errorBox: { background:'#FEE2E2', color:'#991B1B', padding:'10px 12px', borderRadius:9, fontSize:12.5, marginBottom:14, borderLeft:'3px solid #EF4444' },
  field: { marginBottom:14 },
  label: { display:'block', fontSize:11, fontWeight:600, textTransform:'uppercase', letterSpacing:'0.1em', color:'#3D5878', marginBottom:7, fontFamily:"'JetBrains Mono',monospace" },
  input: { width:'100%', padding:'12px 14px', background:'#F7FAFD', border:'1px solid #E4ECF4', borderRadius:10, fontSize:14, transition:'all .15s ease', outline:'none' },
  loginBtn: {
    width:'100%', padding:13, borderRadius:11, background:'#0A2540', color:'white', fontWeight:500, fontSize:14,
    display:'flex', alignItems:'center', justifyContent:'center', gap:8, marginTop:8, border:'none', cursor:'pointer',
    transition:'all .15s ease',
  },
  foot: { marginTop:22, paddingTop:20, borderTop:'1px solid #EEF3F8', display:'flex', alignItems:'center', justifyContent:'space-between', fontSize:11, color:'#7A8BA3', fontFamily:"'JetBrains Mono',monospace" },
};
